
import React from 'react';
import { useData } from '../context/DataContext';

const About: React.FC = () => {
  const { settings } = useData();

  return (
    <div className="min-h-screen bg-white pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="font-display text-5xl font-bold text-gray-900 uppercase tracking-wider mb-8">{settings.aboutTitle}</h1>
        <p className="text-xl text-gray-600 leading-relaxed mb-12 whitespace-pre-line">
          {settings.aboutStory}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="p-6 bg-gray-50 rounded-sm">
            <div className="text-4xl font-display font-bold text-automax-red mb-2">{settings.establishedYear}</div>
            <p className="text-sm text-gray-500">Established in Dar es Salaam</p>
          </div>
          <div className="p-6 bg-gray-50 rounded-sm">
            <div className="text-4xl font-display font-bold text-automax-red mb-2">{settings.establishedYear + 9}</div>
            <p className="text-sm text-gray-500">Expanded to EAC</p>
          </div>
          <div className="p-6 bg-gray-50 rounded-sm">
            <div className="text-4xl font-display font-bold text-automax-red mb-2">{settings.establishedYear + 17}</div>
            <p className="text-sm text-gray-500">Expanded to Central Africa</p>
          </div>
          <div className="p-6 bg-gray-50 rounded-sm">
            <div className="text-4xl font-display font-bold text-automax-red mb-2">{new Date().getFullYear()}</div>
            <p className="text-sm text-gray-500">Reaching 5000+ Units Sold</p>
          </div>
        </div>

        <div className="text-left bg-neutral-900 text-white p-12 rounded-sm shadow-xl relative overflow-hidden">
          <div className="relative z-10">
            <h2 className="font-display text-3xl font-bold uppercase mb-4 text-automax-red">Our Mission</h2>
            <p className="text-gray-300 text-lg whitespace-pre-line">
              {settings.aboutMission}
            </p>
          </div>
          <div className="absolute right-0 bottom-0 opacity-10 transform translate-x-1/4 translate-y-1/4">
            {/* Decorative Element */}
            <svg width="400" height="400" viewBox="0 0 200 200">
              <path fill={settings.logoColor} d="M45,-76C58.3,-69.3,69.2,-58.3,77.8,-46.1C86.4,-33.9,92.7,-20.5,91.8,-7.4C90.9,5.7,82.8,18.5,73.5,29.8C64.2,41.1,53.7,50.9,42.4,59.3C31.1,67.7,19,74.7,6.3,75.9C-6.4,77.1,-19.7,72.5,-32.1,65.2C-44.5,57.9,-56,47.9,-65.4,36.1C-74.8,24.3,-82.1,10.7,-81.2,-2.5C-80.3,-15.7,-71.2,-28.5,-60.9,-39.3C-50.6,-50.1,-39.1,-58.9,-27.2,-66.4C-15.3,-73.9,-3,-80.1,10.2,-81.9C23.4,-83.7,46.8,-81.1,45,-76Z" transform="translate(100 100)" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
